import React, { useEffect, useState } from 'react';
import { 
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, Chip, Typography, Card, TextField, Button, Select, MenuItem, FormControl, InputLabel
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BASEURL } from '../../Constants';
import Nav from './nav';
import { useParams } from 'react-router-dom';

const VishingEmployees = () => {
  const [employeesData, setEmployeesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  // You can search by 'name', 'phone', or 'status'
  const [searchCategory, setSearchCategory] = useState('name');
  const navigate = useNavigate();
  const { pentest_id } = useParams();

  // Fetch employees from backend
  function getEmployees(token) {
    fetch(`${BASEURL}/pentests/vishing/users?pentest_id=${pentest_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        if (data.message === 'Invalid token') {
          navigate('/');
        }
      } else {
        // We only need name, phone, and status for now.
        setEmployeesData(data.users);
      }
    })
    .catch(error => console.error('Error fetching employees:', error));
  }

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      getEmployees(token);
    } else {
      console.error('No token found');
      navigate('/');
    }
  }, [navigate]);

  // Filter employees based on searchTerm and searchCategory
  const filteredEmployees = employeesData.filter(employee => {
    if (!searchTerm) return true;
    const lowerTerm = searchTerm.toLowerCase();

    if (searchCategory === 'name') {
      return employee.name && employee.name.toLowerCase().includes(lowerTerm);
    } else if (searchCategory === 'phone') {
      return employee.phone && employee.phone.toLowerCase().includes(lowerTerm);
    } else if (searchCategory === 'status') {
      return employee.status && employee.status.toLowerCase().includes(lowerTerm);
    }
    return true;
  });

  // Optionally style the status Chip based on status text
  const getStatusChip = (status) => {
    let color = 'default';
    if (status) {
      switch(status.toLowerCase()) {
        case 'active':
          color = 'success';
          break;
        case 'inactive':
          color = 'warning';
          break;
        case 'blocked':
          color = 'error';
          break;
        default:
          color = 'default';
      }
    }
    return <Chip label={status} color={color} variant="outlined" size="small" />;
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f4f6f8' }}>
      {/* Navigation */}
      <Nav />

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Card sx={{ p: 2, borderRadius: '8px', boxShadow: 3 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', ml: 2, mt: 1 }}>
            Employees
          </Typography>
          <Typography variant="body2" gutterBottom sx={{ ml: 2 }}>
            Below is a list of employees with their contact information and current status.
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, m: 2 }}>
            <FormControl sx={{ minWidth: 120 }} size="small">
              <InputLabel>Filter By</InputLabel>
              <Select
                value={searchCategory}
                label="Filter By"
                onChange={e => setSearchCategory(e.target.value)}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="phone">Phone Number</MenuItem>
                <MenuItem value="status">Call Status</MenuItem>
              </Select>
            </FormControl>

            <TextField
              sx={{ flexGrow: 1 }}
              label="Search"
              variant="outlined"
              placeholder="Type to search..."
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button variant="outlined" color="primary" onClick={() => setSearchTerm('')}>
              Clear
            </Button>
          </Box>

          <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: '8px', mt: 2 }}>
            <Table>
              <TableHead sx={{ backgroundColor: '#005CC5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Phone Number</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'white' }}>Call Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredEmployees.length > 0 ? (
                  filteredEmployees.map((employee, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        '&:hover': {
                          backgroundColor: '#f3f3f3',
                        },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 'bold' }}>{employee.name}</TableCell>
                      <TableCell>{employee.phone}</TableCell>
                      <TableCell>{getStatusChip(employee.status)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

        </Card>
      </Box>
    </Box>
  );
};

export default VishingEmployees;
